import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router,ActivatedRoute } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { ToasterService } from '../services/toaster.service';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  providers: [ToasterService]
})
export class ProfileComponent implements OnInit {
  routeParam:any;
  addFamilyButton: boolean = true;
  viewFamilyDetails = true;
  addFamilyDetails: boolean;
  familyData: object = {};
  profileData: any = {};
  addedFamilyRelation: any = [];
  addedFamilyGender: any = [];
  loading: boolean;
  familyMaxDate = new Date();
  private onDestroy$: Subject<void> = new Subject<void>();
  showFormModal:Boolean;
  addModals:any=[];
  familyMembers: any = [];
  addMoreDisbaled:Boolean=false;
  hasCard:Boolean;
  data:any
  // familyObj: object = {
  //   'name': null,
  //   'relationship': null,
  //   'dob': null
  // }
  userId: any;

  constructor(private router: Router, private toasterService: ToasterService, private _location: Location, private serviceURLService: serviceURLService,private aRouter : ActivatedRoute) {

  }

  ngOnInit() {
    this.routeParam = this.aRouter.snapshot.paramMap.get('action'); 
    this.userId = localStorage.getItem('userID');
    this.getProfileDetails();

  }

  CheckIfEcardUser(){
    this.loading=true
    var userId = localStorage.getItem("userID")
    this.serviceURLService.getPoliciesEcards(userId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      const insuranceDetails = successData.response.notifyPolicy;
      this.loading=false
      console.log(insuranceDetails)
      if(insuranceDetails.length>0){
        this.hasCard=true
      }
      else{
        this.hasCard=false
      }
    }, errorData => {
       this.loading = false;
        this.router.navigate(['login']);
    })
  }
  getProfileDetails() {
    this.loading = true;
    console.log("test")
    this.serviceURLService.getProfileDetails(this.userId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
    this.CheckIfEcardUser()
      this.data=successData.response.profileData;
      this.profileData=successData.response.profileData;
      console.log(this.data.family.length)
      if(this.data.family.length==0){
        this.profileData=this.data
        this.showFormModal=true
        this.addMoreDisbaled=true
        this.profileData.family.push({
          name: null,
          relationship: '',
          dob: null,
          gender: '',
          dateOfMarriage: null
      })
      }
      else{
        this.profileData.family=this.data.family
        this.showFormModal=false
        this.addMoreDisbaled=false
      }
      // this.profileData = successData.response.profileData
      console.log(this.profileData.family.length,"profile")
      // if(this.profileData.family.length==1){
      //   this.showFormModal=true
      //   this.addMoreDisbaled=true
      //   this.profileData.family.push({
      //     name: null,
      //     relationship: '',
      //     dob: null
      // })
      // }
      // else{
      //   this.showFormModal=false
      //   this.addMoreDisbaled=false
      // }
      for (let family of this.profileData.family) {
        this.addedFamilyRelation.push(family.relationship);
        this.addedFamilyGender.push(family.gender);
      }
    }, errorData => {
      this.loading = false;
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {

      }
    });
  }

  // showToaster(msg) {
  //   const toaster = document.getElementById('snackbar');
  //   toaster.innerHTML = msg;
  //   toaster.className = 'show';
  //   setTimeout(function () { toaster.className = toaster.className.replace("show", ""); }, 3000);
  // }

  addMoreFamilyMember() {
    const lastObj = this.familyMembers[this.familyMembers.length - 1];
    if (!lastObj.name || !lastObj.relationship || !lastObj.dob) {
      this.toasterService.showErrorToaster('Please enter details first.');
    } else {
      this.familyMembers.push({
        name: null,
        relationship: '',
        dob: null
      });
    }
  }

  addFamilyMemberFields() {
    if(this.addMoreDisbaled){
      this.toasterService.showErrorToaster('Please save your details first');
    }
    else{
      this.addFamilyDetails = true;
      this.viewFamilyDetails = true;
      this.addFamilyButton = false;
      this.showFormModal=true
      this.profileData.family.unshift({
          name: null,
          relationship: '',
          dob: null,
          gender: '',
          dateOfMarriage: null
      })
      this.addMoreDisbaled=true
    }
   
  }
  cancelModal(){
    this.addFamilyDetails = false;
    this.viewFamilyDetails = true;
  }
  addFamilyMembers(form) {
    console.log(form)
    if (!form.valid) {
      this.toasterService.showErrorToaster('Please fill all the fields');
      return;
    }
    this.loading = true;
    for (const member of this.familyMembers) {
      member.dob = (new Date(member.dob).getTime()).toString();
      if (member.dateOfMarriage) {
        member.dateOfMarriage = (new Date(member.dateOfMarriage).getTime()).toString();
      }
    }
    for (const member of this.profileData.family) {
      member.dob = (new Date(member.dob).getTime()).toString();
      if (member.dateOfMarriage) {
        member.dateOfMarriage = (new Date(member.dateOfMarriage).getTime()).toString();
      }
    }
    console.log(this.familyMembers,"fam")
    if (this.profileData.family) {
      for (const member of this.profileData.family) {
        this.familyMembers.push(member);
      }
    }
    const familyArr = {
      family: this.familyMembers
    }
    this.serviceURLService.addFamilyMembers(this.userId, familyArr).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      this.viewFamilyDetails = true;
      this.addFamilyDetails = false;
      this.addFamilyButton = true;
      this.addMoreDisbaled=false;
      this.profileData.family=[]
      this.familyMembers=[]
      this.toasterService.showErrorToaster(successData.message);
      this.getProfileDetails();
    }, errorData => {
      this.loading = false;
    });
  }
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
